module.exports = __webpack_public_path__ + "img/logo_icon.5982bd21.png";